export const createResolveSpaceForReturnUrlPath = (returnUrl: string): string =>
  `/nxt/auth/space/resolve?returnUrl=${encodeURIComponent(returnUrl)}`
